/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Proxies_Not_AllowedInputs */



/**
* | output |
* | --- |
* | "Proxies not allowed" |
*
* @param {Tournament_Proxies_Not_AllowedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_proxies_not_allowed = /** @type {((inputs?: Tournament_Proxies_Not_AllowedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Proxies_Not_AllowedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Proxies non autorisés")
	if (locale === "es") return /** @type {LocalizedString} */ ("Proxies no permitidos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Proxies não permitidos")
	if (locale === "it") return /** @type {LocalizedString} */ ("Proxy non consentiti")
	return /** @type {LocalizedString} */ ("Proxies not allowed")
});